export enum LayoutContainerEnum {
  masterDetail = 'masterDetail',
  tabContainer = 'tabContainer',
  dataTable = 'dataTable',
}
